import { FormEventHandler, FormEvents } from '../../form/events/form_event_handler';
import { ActivityFormEventHandler, ActivityFormEvents } from './activity_form_event_handler';

const subscriptions = [];

export default class ActivityFormEventsProxy {

	static subscribeToFormSubmissionEvents(processInstanceData) {
		ActivityFormEventsProxy.unsubscribeAll();

		subscribeToFormEvent(FormEvents.DEFINITION_LOAD_ERROR, ActivityFormEvents.PROCESS_FORM_DEFINITION_LOAD_ERROR, processInstanceData);
		subscribeToFormEvent(FormEvents.INITIAL_VALUES_LOAD_ERROR, ActivityFormEvents.PROCESS_FORM_INITIAL_VALUES_LOAD_ERROR, processInstanceData);
		subscribeToFormEvent(FormEvents.SUBMIT_SUCCESS, ActivityFormEvents.PROCESS_FORM_SUBMIT_SUCCESS, processInstanceData);
		subscribeToFormEvent(FormEvents.SUBMIT_ERROR, ActivityFormEvents.PROCESS_FORM_SUBMIT_ERROR, processInstanceData);
		subscribeToFormEvent(FormEvents.VALIDATION_ERROR, ActivityFormEvents.PROCESS_FORM_VALIDATION_ERROR, processInstanceData);
	}

	static unsubscribeAll() {
		subscriptions.forEach((subscription) => {
			subscription.unsubscribe();
		});
	}
}

const subscribeToFormEvent = (formEvent, activityFormEvent, processInstanceData) => {
	const proxySubscription = FormEventHandler.subscribe(formEvent, (eventName, ...eventArgs) => {
		eventArgs.unshift(processInstanceData);
		eventArgs.unshift(activityFormEvent);

		ActivityFormEventHandler.publish.apply(ActivityFormEventHandler, eventArgs);
	});

	subscriptions.push(proxySubscription);
};
